<template>
    <header>
        <div class="title">
            <i class="fa-solid fa-viruses"></i>
            Covid-19 Tracker
        </div>
        <p>Api by <a href="https://covid19api.com" target="_blank">covid19api.com</a></p>
    </header>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
header{
    padding: 20px;
    background-color: #3f51b5;
    color: white;
    text-align: center;
    .title{
    font-size: 30px;
    font-weight: bold;
    }
    a{
        color: #aaa;
    }
}

</style>